/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */

export const troubleshootingContent = `
## Troubleshooting Guide

Common issues and their solutions.

### Connection Won't Create

**Problem**: You try to connect two nodes but the connection doesn't work.

**Solutions**:
- Ensure you're dragging from an output handle to an input handle
- Check that the node types are compatible (e.g., output of one matches input of next)
- Verify the target handle isn't already connected (some handles only accept one connection)
- Look for validation error messages that appear

### Transform Not Processing

**Problem**: Your transform node isn't producing output for the output node.

**Solutions**:
- Verify all required inputs are connected
- Check that input data is valid for the transform type
- Look for error messages in the output node
- Try disconnecting and reconnecting nodes
- Verify the input file type is supported

### File Upload Fails

**Problem**: You can't upload a file.

**Solutions**:
- Check that the file type is supported
- Ensure the file isn't corrupted
- Verify file size is within limits
- Try refreshing the page and uploading again

### Project Won't Load

**Problem**: Saved project fails to load.

**Solutions**:
- Check that you have the necessary input files (used in the mapping) uploaded
- Verify the project JSON isn't corrupted (if imported)
- Verify that an API update hasn't taken place since the JSON was created
- Try loading the demo project to verify Dexter is working
- Clear the canvas and try loading again

### Output Download Not Working

**Problem**: Can't download output files.

**Solutions**:
- Ensure the transform has completed processing
- Check that the output node's download button is enabled (it enables once a valid transform result is ready)
- Verify browser isn't blocking downloads
- Try individual download instead of ZIP download and vice-versa

### Performance Issues

**Problem**: Canvas is slow or laggy.

**Solutions**:
- Reduce the number of nodes on canvas
- Close other browser tabs
- Refresh the page (WARNING: Save work beforehand, as refreshing clears the mapping area)
- Clear browser cache
- Check network connection for cloud operations

### General Tips

- Save your work frequently
- Export important mappings as JSON backups
- Keep input files organized in collections
- Use descriptive names for projects and nodes
- Check the browser console for detailed error messages
`;
